import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/spinner.svg")